import { gql } from 'apollo-boost';

export default gql`
  query getRestaurant($input: GetRestaurantInput!) {
    getRestaurant(input: $input) {
      id
      name
      subName
      i18n {
        timezone
      }
      opsSetting {
        disableTakeoutOrderDetailDisplay
        disableDeliveryOrderDetailDisplay
        disableDiningOrderDetailDisplay
      }
      enableTakeoutOrder
      enableDeliveryOrder
    }
  }
`;
